<template>
  <span v-if="field_visible">
    <o-section :title="field_label">
      <table>
        <thead>
          <th
            v-for="(infield, infield_idx) in field.fields"
            v-if="all_items.length > 0"
          >
            {{ infield.name }}
          </th>
          <th v-if="!is_disabled">
            <b-button @click="addEntry">{{
              field.add_text || "Add Entry"
            }}</b-button>
          </th>
        </thead>
        <tr v-for="(entry, entry_idx) in all_items" :key="getKey(entry)">
          <td v-for="(infield, infield_idx) in field.fields" :key="infield_idx">
            <f-widget
              :design="design"
              :disabled="is_disabled"
              :field="infield"
              :field_index="infield_idx"
              :fields="field.fields"
              :form-state="formState"
              :form-context="nestedFormContext"
              :selector="selector"
              @change="changeRow(entry_idx, $event)"
              @error="handleError"
              @fields-change="fieldsChanged"
              in-table
              v-model="_current_values[entry_idx]"
            ></f-widget>
          </td>
          <td v-if="!is_disabled">
            <o-list-actions
              :disable-delete="atMin"
              :index="entry_idx"
              :list="_current_values"
            />
          </td>
        </tr>
      </table>
    </o-section>
  </span>
</template>

<script>
import OListActions from "../../../vue-ocom/components/table/OListActions.vue";
import OSection from "../../../vue-ocom/components/layout/OSection.vue";
import MultipleContainerMixin from "../MultipleContainerMixin.js";
import { generateGUID } from "../../utils";

export default {
  name: "TableWidget",
  mixins: [MultipleContainerMixin],
  components: { OSection, OListActions },
  methods: {
    // Overrides MultipleContainerMixin
    fieldsChanged: function () {
      // This code Is missing:
      // this.field.fields = fields;
      // TODO: is the above needed???

      this.$emit("fields-change", this.fields);
    },
    getKey(entry) {
      if (!entry.__uuid) {
        entry.__uuid = generateGUID();
      }

      return entry.__uuid;
    },
  },
};
</script>

<style scoped></style>
